import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'
import { TKeyInitiative } from 'partner360/entities/keyInitiatives'
import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'
import {
  getPlanField,
  getPrevYearActualsField,
} from 'partner360/features/keyInitiatives/lib/financialFieldHelper'
import { TKeyInitiativesFinancialData } from 'partner360/features/keyInitiatives/model/financialData'
import { getInitiativeIncrementalField } from 'partner360/features/keyInitiatives/ui/helpers/fieldHelper'
import { formatMoney } from 'partner360/features/keyInitiatives/ui/helpers/formatMoney'
import { getNumberValue } from 'partner360/features/keyInitiatives/ui/helpers/getNumberValue'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { KpiProgressBar } from '../common/kpiProgressBar/KpiProgressBar'
import { KpiTile } from '../common/kpiTile/KpiTile'

interface IIncrementalCardContentProps {
  kiData: TKeyInitiative[]
  finData: TKeyInitiativesFinancialData[]
  activeCurrency: string
  actualsType: ActualsValueTypes
}

export const TotalIncremental: FC<IIncrementalCardContentProps> = ({
  kiData,
  finData,
  actualsType,
  activeCurrency,
}) => {
  const { incremental, target } = useMemo(() => {
    const incrementalField = getInitiativeIncrementalField(actualsType, activeCurrency)
    const planField = getPlanField(actualsType, activeCurrency)
    const prevYearActualsField = getPrevYearActualsField(actualsType, activeCurrency)

    const incrementalValue = kiData.reduce((sum, item) => {
      return sum + getNumberValue(item, incrementalField)
    }, 0)

    const finItem = finData[0]

    const currentYearPlan = getNumberValue(finItem, planField)

    const prevYearActuals = getNumberValue(finItem, prevYearActualsField)
    const targetValue = currentYearPlan - prevYearActuals

    return {
      incremental: incrementalValue,
      target: targetValue,
    }
  }, [kiData, finData, actualsType, activeCurrency])

  return (
    <KpiTile
      title={TRANSLATION_KEYS.dashboard.aggregatedView.incremental.title}
      value={formatMoney(incremental, activeCurrency)}
      footer={
        <KpiProgressBar
          label={
            <Translation
              text={TRANSLATION_KEYS.dashboard.aggregatedView.incremental.footer}
              replaceParams={[{ key: '{target}', value: formatMoney(target, activeCurrency) }]}
              span
            />
          }
          target={target}
          value={incremental}
        />
      }
    />
  )
}
